import { render, staticRenderFns } from "./CustomerUserEditDetailsTab.vue?vue&type=template&id=34ebd3db"
import script from "./CustomerUserEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerUserEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports